var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "popupSelect-input", on: { click: _vm.openDialog } },
        [
          _c("el-button", { attrs: { type: "text" } }, [
            _vm._v("设置表头顺序 "),
          ]),
        ],
        1
      ),
      _vm.visible
        ? _c(
            "el-dialog",
            {
              staticClass: "Weforsys-dialog Weforsys-dialog_center",
              attrs: {
                title: "设置表头顺序",
                "close-on-click-modal": false,
                visible: _vm.visible,
                "lock-scroll": "",
                width: "1200px",
                "append-to-body": true,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.visible = $event
                },
              },
            },
            [
              _c(
                "el-table",
                _vm._g(
                  _vm._b(
                    {
                      ref: "WeforsysTablests",
                      staticClass: "Weforsys-common-table",
                      attrs: {
                        data: _vm.data,
                        height: "80px",
                        "element-loading-text": _vm.$t("common.loadingText"),
                        border: false,
                        "row-key": _vm.onlyid,
                        id: "sortableList",
                      },
                    },
                    "el-table",
                    _vm.$attrs,
                    false
                  ),
                  _vm.$listeners
                ),
                [
                  _vm._l(
                    this.pageConfig.length == 0 ? _vm.col : this.collist,
                    function (item, index) {
                      return _c("el-table-column", {
                        key: "col_" + index,
                        attrs: {
                          prop:
                            _vm.pageConfig.length == 0
                              ? _vm.dropCol[index].prop
                              : _vm.collist[index].prop,
                          label: item.label,
                          width: 120,
                        },
                      })
                    }
                  ),
                  _vm._t("default"),
                  _c(
                    "template",
                    { slot: "empty" },
                    [
                      _c("el-empty", {
                        attrs: { description: "", "image-size": 120 },
                      }),
                    ],
                    1
                  ),
                ],
                2
              ),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.visible = false
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        { name: "no-more-click", rawName: "v-no-more-click" },
                      ],
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.dataFormSubmit()
                        },
                      },
                    },
                    [_vm._v("确 定")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }